/**
 * Created by LID4JCU on 02/15/2017.
 */
module.exports = function (app) {
    "use strict";
    app.controller('pages.resources', ["$state", "$scope", "sessionData", "$filter", "modal", "$timeout", "coremetrics", function ($state, $scope, sessionData, $filter, modal, $timeout, coremetrics) {

        if ((sessionData.entitlements.clientStatus.cancelled == true)
            && (!sessionData.cancelledClientHasAgreed)) {
            $state.go('cancelledConditions');
        }

        //    Sidebar
        $scope.sidebar = {
            breadCrumb: {
            },
            betterBreadcrumbs: [
            // {
            //     title: "Resources",
            //     state: "resources"
            // }
            ],
            links: (window.aemSiteData || []).reduce(function(a,c,i) {
                if (c.path.length === 2) {
                    a.push({
                        heading: c.page.props["navTitle"] || "Missing Heading",
                        label: c.page.props["navTitle"] || "Missing Label",
                        state: c.path.join('.'),
                        description: c.page.props["jcr:description"] || "Missing Description"
                    })
                }
                return a;
            }, [])
        };

        $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
            $scope.sidebar.links.forEach(function(link) {
                if (toState && toState.name && toState.name.substring(0, link.state.length) == link.state) {
                    $timeout((function(link) { return function() {
                        $scope.sidebar.setActive(link);
                    }})(link), 50);
                }
            });
            if (toState.name == "resources") {
                // Reources landing should force them to the 1st child
                if ($scope.sidebar.links && $scope.sidebar.links[0]) {
                    $state.go($scope.sidebar.links[0].state);
                }
            }
        });

        //Initialize
        coremetrics.pageviewTag('EMPLOYERS:RESOURCES:LANDING PAGE', 'EMPLOYERS:RESOURCES');

        //Page Buttons

    }]);


    var template = '';


	if (Array.isArray(window.aemSiteData)) {
		window.aemSiteData[0].page.children.forEach(function(child) {
			template += "<a data-ui-sref=\"" + child.path.join('.') + "\">" + (child.props["navTitle"] || "Missing Label") + "</a>";
			template += "<p>" + (child.props["jcr:description"] || "Missing Description") + "</p>";
		});
	}
    template = '<section data-ui-view="resources" style="min-height: 400px;">' + template + '</section>';

    return [
        {
            state: "resources",
            url: "/resources",
            views: {
                'body@': {
                    //template: bootstrap.templates['page-templates/hmhs/content-page.html'],
                    // template: bootstrap.templates['page-templates/category.html'],
                    template: bootstrap.templates['page-templates/hmhs/content-page-side-bar.html'],
                    controller: "pages.resources",
                },
                "content@resources": {
                    template: template,
                    controller: ["$scope", function ($scope) {
                        delete $scope.sidebar.breadCrumb.secondary;
                    }]
                }
            }
        }
        // }, {
        //     state: "resources.contactInformation",
        //     url: "/contact-information",
        //     views: {
        //         "content@resources": {
        //             templateUrl: "resources/contact-information.employerTemplate.html/pages/resources/contactInformation",
        //             controller: ["$scope", function ($scope) {
        //                 $scope.sidebar.breadCrumb.secondary = {
        //                     title: "Contact Information"
        //                 };
        //             }]
        //         }
        //     }
        // },
        // {
        //     state: "resources.formsApplications",
        //     url: "/forms-applications",
        //     views: {
        //         "content@resources": {
        //             templateUrl: "resources/forms-applications.employerTemplate.html/pages/resources/formsApplications",
        //             controller: ["$scope", function ($scope) {
        //                 $scope.sidebar.breadCrumb.secondary = {
        //                     title: "Forms & Applications"
        //                 };
        //             }]
        //         }
        //     }
        // },
        // {
        //     state: "resources.websiteStatus",
        //     url: "/website-status",
        //     views: {
        //         "content@resources": {
        //             templateUrl: "resources/website-status.employerTemplate.html/pages/resources/websiteStatus",
        //             controller: ["$scope", function ($scope) {
        //                 $scope.sidebar.breadCrumb.secondary = {
        //                     title: "Website Status"
        //                 };
        //             }]
        //         }
        //     }
        // },
        // {
        //     state: "resources.helpfulInformation",
        //     url: "/helpful-information",
        //     views: {
        //         "content@resources": {
        //             templateUrl: "resources/helpful-information.employerTemplate.html/pages/resources/helpfulInformation",
        //             controller: ["$scope", function ($scope) {
        //                 $scope.sidebar.breadCrumb.secondary = {
        //                     title: "Helpful Information"
        //                 };
        //             }]
        //         }
        //     }
        // },
        // {
        //     state: "resources.groupBulletins",
        //     url: "/group-bulletins",
        //     views: {
        //         "content@resources": {
        //             templateUrl: "resources/group-bulletins.employerTemplate.html/pages/resources/groupBulletins",
        //             controller: ["$scope", function ($scope) {
        //                 $scope.sidebar.breadCrumb.secondary = {
        //                     title: "Group Bulletins"
        //                 };
        //             }]
        //         }
        //     }
        // },
        // {
        //     state: "resources.communicationsToolkit",
        //     url: "/communications-toolkit",
        //     views: {
        //         "content@resources": {
        //             templateUrl: "resources/communications-toolkit.employerTemplate.html/pages/resources/communicationsToolkit",
        //             controller: ["$scope", function ($scope) {
        //                 $scope.sidebar.breadCrumb.secondary = {
        //                     title: "Consumer Communications Toolkit"
        //                 };
        //             }]
        //         }
        //     }
        // }
    ];
};
